import { useEffect, useRef } from 'react';
import api from '@/utils/api';
import { getFingerprintSafe } from '@/components/login/loginHelpers';

// While the OTP screen is up, poll every 3s; if the user tapped "Approve" in the
// email, complete the sign-in automatically.
export default function useMagicLinkPolling(sessionId, onApproved, onExpired) {
  const callbacks = useRef({ onApproved, onExpired });
  callbacks.current = { onApproved, onExpired };

  useEffect(() => {
    if (!sessionId) return undefined;
    let mounted = true;
    let inFlight = false;
    const tick = async () => {
      if (!mounted || inFlight) return;
      inFlight = true;
      try {
        const s = await api.get(`/auth/login-otp/status?session_id=${encodeURIComponent(sessionId)}`);
        if (!mounted) return;
        if (s.data?.approved && !s.data?.consumed) {
          const device_fingerprint = await getFingerprintSafe();
          const res = await api.post('/auth/login-magic-complete', { otp_session_id: sessionId, device_fingerprint });
          if (mounted) callbacks.current.onApproved(res.data);
        } else if (s.data?.expired) {
          callbacks.current.onExpired();
        }
      } catch {
        // Polling failures are non-fatal; the user can still type the code.
      } finally {
        inFlight = false;
      }
    };
    const id = setInterval(tick, 3000);
    return () => { mounted = false; clearInterval(id); };
  }, [sessionId]);
}
